const providers = [
	{
		type: 'channel',
		regex: /^https?:\/\/www\.twitch.tv\/([^\/?]+)/i,
		src: 'https://player.twitch.tv/?channel=',
	},
	{
		type: 'videos',
		regex: /^https?:\/\/www\.twitch.tv\/videos\/(\d+)?/i,
		src: 'https://player.twitch.tv/?video=v',
	},
	{
		type: 'clip',
		regex: /^https?:\/\/www\.twitch.tv\/[^\/?]+\/clip\/([^\/?]+)/i,
		src: 'https://clips.twitch.tv/embed?clip=',
	},
];

/**
 * Find video type and corresponding iframe source.
 *
 * @param {string} url Embed URL.
 * @return {Object|undefined} Embeded video information.
 */
export const findVideoType = ( url ) => {
	let type = { type: null, src: null };

	for ( const provider of providers ) {
		const found = url.match( provider.regex );

		if ( found !== null && found[ 1 ] !== undefined ) {
			type = {
				type: provider.type,
				src: `${ provider.src }${ found[ 1 ] }&autoplay=false`,
			};
		}
	}

	return type;
};

export const getIframeHtml = ( src ) => {
	return (
		<iframe
			src={ src }
			title="Embedded content from twitch.tv"
			width="640"
			height="360"
			frameBorder="0"
			scrolling="no"
			allowFullScreen={ true }>
		</iframe>
	);
};
